import { TerminUpdateApi } from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';
import TerminUpdate from '../../model/TerminUpdate';

const client = new TerminUpdateApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const updateTermin = async (
  terminUuid: Uuid,
  terminUpdate: TerminUpdate,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<void>> => {
  const { data, status } = await client.updateTermin(terminUuid, terminUpdate, options);
  return { data, responseCode: status };
};
